import type { FetchConfig } from '@nlo/nuxt-common/api/helper-types';
import type { paths } from '../../generated/portal-api';

export type QueryParams = NonNullable<paths['/api/search']['get']['parameters']['query']>;

export function createCustomerServiceSearchApi(fetchConfig: FetchConfig) {
	const client = fetchConfig.createClient<paths>();

	return {
		getCustomerServiceSearchResults(queryParams: QueryParams) {
			return client.GET('/api/search', { params: { query: queryParams } });
		},
	};
}
